import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { unix } from 'moment';

@Component({
  selector: 'kt-task-comments',
  templateUrl: './task-comments.component.html',
  styleUrls: ['./task-comments.component.scss'],
})
export class TaskCommentsComponent {
  comments = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TaskCommentsComponent>,
  ) {
    this.comments = this.data;
  }

  getFormattedDate(timestamp) {
    return unix(timestamp / 1000).format('YYYY-MM-DD hh:mm a');
  }

  close() {
    this.dialogRef.close();
  }
}
